import { Injectable } from '@angular/core';
import { ConnectionService } from '@services/connection-service';
import { UserService } from '@services/user/user.service';
import { PersonalisedPromotion } from '@cureskin/api-client/src/server-api/api';

@Injectable({ providedIn: 'root' })
export class PersonalisedPromotionsService {
  constructor(
    private readonly conn: ConnectionService,
    private readonly userService: UserService,
  ) {}

  loadPersonalisedPromotions(): Promise<PersonalisedPromotion[]> {
    return this.conn.getPersonalisedPromotions();
  }

  async isAOVActiveInPersonalisedPromotions(user: any): Promise<boolean> {
    if (!user || !this.userService.isPaidUser(user)) {
      return false;
    }
    const promotions = await this.loadPersonalisedPromotions();
    return promotions.includes(PersonalisedPromotion.AOV);
  }
}
